// l10n status: done
import { CreateComponent } from "components/utils/CreateComponent"
import React from "react"
// import { rootStore } from "store/RootStore"
//  NEVER-USED import { RecordingsMenuIcons } from "../scenes/Recordings/components/RecordingsMenuIcons"
import { RouteTab, RouteTabs } from "./utils/RouteTab"
import { useMediaQuery } from "hooks/useMediaQyery"
import { l10n } from "store/lang/L10n"
import DiscoverSvgWhite from 'img/icons/tab_discover_white.svg'
import DiscoverSvgRed from 'img/icons/tab_discover_red.svg'
import LiveTvSvgWhite from 'img/icons/tab_livetv_white.svg'
import LiveTvSvgRed from 'img/icons/tab_livetv_red.svg'
import TvGuideSvgWhite from 'img/icons/tab_tvguide_white.svg'
import TvGuideSvgRed from 'img/icons/tab_tvguide_red.svg'
import RecordingsSvgWhite from 'img/icons/tab_recordings_white.svg'
import RecordingsSvgRed from 'img/icons/tab_recordings_red.svg'
import RadioSvgWhite from 'img/icons/tab_radio_white.svg'
import RadioSvgRed from 'img/icons/tab_radio_red.svg'
import { useLocation } from "react-router"
import { usePreviousLocation } from "hooks/PreviousLocationProvider"
import { appFeatures } from "AppFeatures"

const styles = theme => ({
	// MTV-1691: don't use margin: "0 auto" since the item 'TV GUIDE' would disappear when clicking on 'AUFNAHMEN' 
	TopMenuWrapper: { margin: 0, display: "flex", minHeight: 40 },
	TopMenuTabs: { flexGrow: 1, minHeight: 40 }, //boxShadow: theme.shadows[5],
	TabItem: { minWidth: 80, width: 180, minHeight: 60 },
	indicator: { backgroundColor: theme.palette.primary["main"] },
	/*
	root: {
		flexShrink: 4,
		//marginTop: theme.spacing.unit * 3,
		//backgroundColor: theme.palette.background.paper,
	},
	tabRoot: {
		width: "64px !important",
	},
	*/
})

function SvgIcon({ icon, selected }) {
	const icons = [
		{ name: "Discover", route: "/",
		icon: { default: DiscoverSvgWhite, selected: DiscoverSvgRed, scale: 1.1 } },
		{ name: "LiveTv", route: "/livetv",
		  icon: { default: LiveTvSvgWhite, selected: LiveTvSvgRed, scale: 0.9 } },
		{ name: "TvGuide", route: "/tv-guide",
		  icon: { default: TvGuideSvgWhite, selected: TvGuideSvgRed, scale: 0.8 } },
		{ name: "Recordings", route: "/recordings",
		  icon: { default: RecordingsSvgWhite, selected: RecordingsSvgRed, scale: 1 } },
		{ name: "Radio", route: "/radio",
			icon: { default: RadioSvgWhite, selected: RadioSvgRed, scale: 1.2 } }
	]

	const item = icons.find((element) => element.name === icon)
	const iconSrc = item.route !== selected ? item.icon.default : item.icon.selected

	/* MTVW-1078: replaced for label with textOverflow/ellipsis
	return (
		<div style={{ width: 32, height: 32, paddingBottom: 6 }}>
			<img style={{ width: 24, height: 24 }} src={iconSrc}></img>
		</div>
	)
	*/
	return (
		<div style={{ paddingBottom: 6, paddingTop: 4 }}>
			<img style={{ transform: `scale(${item.icon.scale})`, display: 'block', height: 24 /*, width: "calc(98vw / 5)", maxWidth: "calc(98vw / 5)",*/ }} src={iconSrc}></img>
		</div>
	)
}

export const TopMenu = CreateComponent(styles, false, true, ({ classes }) => {
	const location = useLocation()
	const previousLocation = usePreviousLocation()

	React.useEffect(() => {
		if (locationRef?.current) locationRef.current = location?.pathname
		return () => {
		}
	}, [])

	// MTVW-966: replaced with locationRef
	//const [value, setValue] = React.useState("/") // preset for "Discover"
	const locationRef = React.useRef("/") // preset for "Discover"
	// MTVW-918
	const isMobile = useMediaQuery('(max-width: 540px)')

	if (location?.pathname && previousLocation?.pathname && location?.pathname !== locationRef.current) {
		rootStore.page.Discover.notifyTabChange(locationRef.current, location?.pathname)
		locationRef.current = location?.pathname
	}

	const handleTabChange = (event, newValue) => {
		// MTVW-966: replaced with notifyTabChange above
		return
		/*
		// MTVW-996
		if (newValue !== value || value === null) {
			rootStore.page.Discover.notifyTabChange(value, newValue)
			setValue(newValue)
		}
		*/
	}

	// MTVW-1055: language setting, useEffect to re-render after language change
	const [isoLang, setIsoLang] = React.useState(rootStore?.sso?.browserStore?.getLanguage())
	React.useEffect(() => {
		//console.debug("TopMenu", rootStore?.sso?.browserStore?.getLanguage())
		setIsoLang(rootStore?.sso?.browserStore?.getLanguage())
	}, [rootStore?.sso?.browserStore?.languageUpdated])

	return (
		<>
			{!isMobile &&
				<div className={classes.TopMenuWrapper}>
					{/* MTVW-881, MTVW-918: change the bar below the selected tab */}
					<RouteTabs
						onChange={handleTabChange}
						slotProps={{ indicator: { style: { backgroundColor: "#FFF" }, className: classes.indicator } }}
						centered
						className={classes.TopMenuTabs}
						routeCustomName="top_menu"
					>
						<RouteTab className={classes.TabItem + " LinkItemNavBar"} label={l10n.featureDiscoverTitle} value="Discover" data-test="discover" />
						<RouteTab className={classes.TabItem + " LinkItemNavBar"} label={l10n.featureLiveTvTitle} value="LiveTv" data-test="livetv" />
						<RouteTab className={classes.TabItem + " LinkItemNavBar"} label={l10n.featureTvGuideTitle} value="TvGuide" data-test="tvguide" />
						<RouteTab className={classes.TabItem + " LinkItemNavBar"} label={l10n.featureRecordingsTitle} value="Recordings" data-test="recordings" />
						{appFeatures.radioEnabled &&
							<RouteTab className={classes.TabItem + " LinkItemNavBar"} label={l10n.featureRadioTitle} value="Radio" data-test="radio" />
						}
					</RouteTabs>
					{/* NEVER-USED {rootStore.page.Recordings.isVisible && <RecordingsMenuIcons page={rootStore.page.Recordings} />} */}
				</div>
			}
			{/* MTVW-918 */}
			{isMobile &&
				// MTVW-881: change the bar below the selected tab
				<RouteTabs
					onChange={handleTabChange}
					slotProps={{ indicator: { style: { backgroundColor: "#191919" }, className: classes.indicator } }}
					variant="fullWidth"
					centered
					className={classes.TopMenuTabs}
					routeCustomName="top_menu"
				>
					<RouteTab icon={<SvgIcon icon={"Discover"} selected={location?.pathname} />} className={classes.TabItem + " LinkItemNavBar"} label={l10n.featureDiscoverTitle} value="Discover" data-test="discover" />
					<RouteTab icon={<SvgIcon icon={"LiveTv"} selected={location?.pathname} />} className={classes.TabItem + " LinkItemNavBar"} label={l10n.featureLiveTvTitle} value="LiveTv" data-test="livetv" />
					<RouteTab icon={<SvgIcon icon={"TvGuide"} selected={location?.pathname} />} className={classes.TabItem + " LinkItemNavBar"} label={l10n.featureTvGuideTitle} value="TvGuide" data-test="tvguide" />
					<RouteTab icon={<SvgIcon icon={"Recordings"} selected={location?.pathname} />} className={classes.TabItem + " LinkItemNavBar"} label={l10n.featureRecordingsTitle} value="Recordings" data-test="recordings" />
					{appFeatures.radioEnabled &&
						<RouteTab icon={<SvgIcon icon={"Radio"} selected={location?.pathname} />} className={classes.TabItem + " LinkItemNavBar"} label={l10n.featureRadioTitle} value="Radio" data-test="radio" />
					}
				</RouteTabs>
			}
		</>
	)
})
